import { checkManagerAuthorization } from 'helpers/authorization';
import _ from 'lodash';
import React, { useState  } from 'react';
import { Container, Message, Tab } from 'semantic-ui-react'
import ImpersonateBuyer from '../../components/ImpersonateUsers/ImpersonateBuyer';
import ImpersonateSeller from '../../components/ImpersonateUsers/ImpersonateSeller';
import featuresList from '../../constants/FeaturesList';
import { connect } from 'react-redux';
import './ImpersonateUsers.less'

const ImpersonateUsers = (props) => {
const [message, setMessage] = useState('');

const panes = [/*

    { menuItem: 'Seller', pane: (<Tab.Pane key='tab1'> <ImpersonateSeller /> </Tab.Pane>) },
    { menuItem: 'Buyer', pane: (<Tab.Pane key='tab2'> <ImpersonateBuyer /> </Tab.Pane>) }*/
]

if(checkManagerAuthorization(featuresList.IMPERSONATE_BUYER, props.currentUser)){
    panes.push({ menuItem: 'Buyer', pane: (<Tab.Pane key='tab2'> <ImpersonateBuyer /> </Tab.Pane>) })
}
if(checkManagerAuthorization(featuresList.IMPERSONATE_SELLER, props.currentUser)){
    panes.push({ menuItem: 'Seller', pane: (<Tab.Pane key='tab1'> <ImpersonateSeller /> </Tab.Pane>) })
}


return (
    <Container fluid className="impersonate-container">
        <div className="main-page-panel">
            <div className="content-panel">
                <div className="mobile-header">
                    <div className="main-heading">
                    Impersonate
                    </div>
                </div>

                {message ? <Message>
                    <Message.Header>Impersonate</Message.Header>
                    <p>
                        {message}
                    </p>
                </Message> : ''}
                <Tab panes={panes} renderActiveOnly={false} className="filter-segment" />


            </div>
        </div>

    </Container>
)

}

function mapStateToProps({ auth, reducer, appView, locationDetails, searchForm }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component

    return {
        loggedIn: auth.loggedIn,
        currentUser: auth.currentUser,
        loginError: auth.loginError,
        homeScreenLoading: reducer.homeScreenLoading,
        showSidebar: appView.showSidebar,
        locationEnabled: locationDetails.locationEnabled,
        lat: locationDetails.lat,
        lon: locationDetails.lon,
        showSearchFormInHeader: searchForm.showSearchBarInHeader,
    }
}

export default connect(mapStateToProps, null)(ImpersonateUsers);
//export default ImpersonateUsers;